import React, {PropTypes}  from 'react';
import About from './About';
import Api from './Api';
import Share from './Share';
import Sources from './Sources';
import LocationCustomize from '../containers/LocationCustomize.js';
import CurrencyCustomize from '../containers/CurrencyCustomize.js';

class Modals extends React.Component {

  componentDidMount () {
    let that = this;

    // When a modal is open
    $('.modal').on('show.bs.modal', function (e) {
        // Add #modal_name to the url
        if (typeof (e.relatedTarget) != "undefined") {
          window.location.hash = $(e.relatedTarget).attr('href');
        }

        // Stop the autoplay
        that.props.autoplayActions.autoplayStop();
    });

    // When a modal is closed, remove #modal_name from the url
    $('.modal').on('hide.bs.modal', function () {
      // http://stackoverflow.com/questions/1397329/how-to-remove-the-hash-from-window-location-with-javascript-without-page-refresh/5298684#5298684
      history.replaceState("", document.title, window.location.pathname + window.location.search);
    });

    // Permalinks
    if(window.location.hash) {
      let hash = window.location.hash;
      $(hash).modal('toggle');
    }
  }

  render() {
    return (
      <div>
        <About />
        <Api />
        <Share />
        <Sources />
        <LocationCustomize />
        <CurrencyCustomize />
      </div>
    );
  }
}

Modals.propTypes = {
  autoplayActions: PropTypes.object.isRequired
};

export default Modals;



/** WEBPACK FOOTER **
 ** ./src/components/Modals.js
 **/